import { render, staticRenderFns } from "./shippedOrder.vue?vue&type=template&id=1399bb3a&scoped=true&"
import script from "./shippedOrder.vue?vue&type=script&lang=js&"
export * from "./shippedOrder.vue?vue&type=script&lang=js&"
import style0 from "./shippedOrder.vue?vue&type=style&index=0&id=1399bb3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1399bb3a",
  null
  
)

export default component.exports